import { CommonModule } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialog } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { normalizarValorOrdenacao } from '../../../shared/helpers/ordenacao-tabela.helper';
import { MatTooltipModule } from '@angular/material/tooltip';
import { Router } from '@angular/router';
import { SelectionModel } from '@angular/cdk/collections';
import { ConfirmModalComponent } from '../../../shared/components/confirm-modal/confirm-modal.component';
import { EmptyListComponent } from '../../../shared/components/empty-list/empty-list.component';
import { HeaderComponent } from '../../../shared/components/header/header.component';
import { LoadingBoxDefaultListComponent } from '../../../shared/components/loading-box-default-list/loading-box-default-list.component';
import { FuncionalidadeEnum } from '../../../shared/enums/usuario/funcionalidade.enum';
import { ModuloEnum } from '../../../shared/enums/usuario/modulo.enum';
import { AlertService, AlertType } from '../../../shared/services/alert.service';
import { TransferenciaEstoqueService } from '../../../shared/services/apis/suprimentos/transferencia-estoque.service';
import { TransferenciaOrquestradorService } from '../../../shared/services/apis/orquestrador-suprimentos/transferencia-orquestrador.service';
import { TransferenciaEstoqueListStruct } from '../../../shared/services/structs/suprimentos/transferencia-estoque-list.struct';
import { MatBadgeModule } from '@angular/material/badge';
import { LookupService as ProdutoLookupService } from '../../../shared/services/apis/produto/produto-lookup.service';
import { LookupItemStruct } from '../../../shared/services/structs/pessoa/lookup-item.struct';
import { StatusTransferenciaEnum } from '../../../shared/enums/suprimentos/status-transferencia.enum';

@Component({
  selector: 'app-transferencia-estoque-lista',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    HeaderComponent,
    LoadingBoxDefaultListComponent,
    EmptyListComponent,
    MatButtonModule,
    MatCheckboxModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatIconModule,
    MatTableModule,
    MatSortModule,
    MatMenuModule,
    MatTooltipModule,
    MatProgressSpinnerModule,
    MatBadgeModule,
  ],
  templateUrl: './transferencia-estoque-lista.component.html',
  styleUrl: './transferencia-estoque-lista.component.css',
})
export class TransferenciaEstoqueListaComponent implements OnInit {
  public moduloEnum = ModuloEnum.Suprimentos;
  public funcionalidadeEnum = FuncionalidadeEnum.Suprimentos_ControleEstoque;
  public statusTransferenciaEnum = StatusTransferenciaEnum;

  public isLoading = false;
  public dataSource = new MatTableDataSource<TransferenciaEstoqueListStruct>([]);
  public displayedColumns = ['select', 'datetimeInclusao', 'origem', 'destino', 'status', 'acoes'];

  @ViewChild(MatSort) set matSort(sort: MatSort) {
    if (!sort) return;
    this.dataSource.sort = sort;
    this.dataSource.sortingDataAccessor = (item, property) => {
      switch (property) {
        case 'origem':
          return normalizarValorOrdenacao(item.descricaoOrigem ?? `Local #${item.idLocalizacaoEstoqueOrigem}`);
        case 'destino':
          return normalizarValorOrdenacao(item.descricaoDestino ?? `Local #${item.idLocalizacaoEstoqueDestino}`);
        default:
          return normalizarValorOrdenacao((item as any)[property]);
      }
    };
  }
  public totalRegistros = 0;
  public paginaAtual = 1;
  public tamanhoPagina = 20;
  public _ultimaPagina = false;

  public pesquisa: string = '';
  public filtroStatus: number | null = null;
  public statuses: { idStatusTransferencia: number; descricao: string }[] = [];
  public localizacoes: LookupItemStruct[] = [];

  public selection = new SelectionModel<TransferenciaEstoqueListStruct>(true, []);

  public get qtdFiltrosAtivos(): number {
    let count = 0;
    if (this.filtroStatus !== null) count++;
    return count;
  }

  constructor(
    private router: Router,
    private dialog: MatDialog,
    private alertService: AlertService,
    private transferenciaEstoqueService: TransferenciaEstoqueService,
    private transferenciaOrquestradorService: TransferenciaOrquestradorService,
    private produtoLookupService: ProdutoLookupService
  ) { }

  ngOnInit(): void {
    this.carregarLookup();
    this.carregarLocalizacoes();
    this.carregar();
  }

  public voltar(): void {
    this.router.navigate(['/suprimentos/controle-estoque']);
  }

  private carregarLookup(): void {
    this.transferenciaEstoqueService.getLookup().subscribe({
      next: (resp) => { if (!resp?.isError) this.statuses = resp.statuses ?? []; },
    });
  }

  private carregarLocalizacoes(): void {
    this.produtoLookupService.getLocalizacaoEstoqueSelect().subscribe({
      next: (resp) => {
        if (!resp?.isError) {
          this.localizacoes = resp.list ?? [];
          this.resolverNomesLocalizacoes();
        }
      },
    });
  }

  private resolverNomesLocalizacoes(): void {
    if (!this.localizacoes.length) return;
    for (const item of this.dataSource.data) {
      if (!item.descricaoOrigem && item.idLocalizacaoEstoqueOrigem) {
        item.descricaoOrigem = this.localizacoes.find(l => l.id === item.idLocalizacaoEstoqueOrigem)?.descricao;
      }
      if (!item.descricaoDestino && item.idLocalizacaoEstoqueDestino) {
        item.descricaoDestino = this.localizacoes.find(l => l.id === item.idLocalizacaoEstoqueDestino)?.descricao;
      }
    }
  }

  public clickPesquisar(): void {
    this.paginaAtual = 1;
    this.dataSource.data = [];
    this._ultimaPagina = false;
    this.selection.clear();
    this.carregar();
  }

  public limparFiltros(): void {
    this.pesquisa = '';
    this.filtroStatus = null;
    this.clickPesquisar();
  }

  public proximaPagina(): void {
    this.paginaAtual++;
    this.carregar();
  }

  public carregar(): void {
    this.isLoading = true;
    this.transferenciaEstoqueService.getAll({
      idStatus: this.filtroStatus ?? undefined,
      pagina: this.paginaAtual,
      tamanhoPagina: this.tamanhoPagina,
    }).subscribe({
      next: (resp) => {
        this.isLoading = false;
        if (!resp?.isError) {
          const novos = resp.listaTransferencias ?? [];
          this.dataSource.data = this.paginaAtual === 1 ? novos : [...this.dataSource.data, ...novos];
          this.totalRegistros = resp.totalRegistros ?? 0;
          this._ultimaPagina = this.dataSource.data.length >= this.totalRegistros;
          this.resolverNomesLocalizacoes();
        } else {
          this.alertService.show('Erro', resp.errorDescription, AlertType.error);
        }
      },
      error: () => {
        this.isLoading = false;
        this.alertService.show('Erro', 'Não foi possível carregar as transferências.', AlertType.error);
      },
    });
  }

  public nova(): void {
    this.router.navigate(['/suprimentos/transferencia-estoque/cadastrar']);
  }

  public abrir(item: TransferenciaEstoqueListStruct): void {
    this.router.navigate(['/suprimentos/transferencia-estoque/editar', item.idTransferenciaEstoque]);
  }

  public excluir(item: TransferenciaEstoqueListStruct): void {
    const isConcluida = item.idStatusTransferencia === StatusTransferenciaEnum.Concluido;
    const dialogRef = this.dialog.open(ConfirmModalComponent, {
      data: {
        title: 'Excluir transferência',
        description: isConcluida
          ? `Esta transferência já foi realizada — excluí-la vai reverter a movimentação de estoque nos dois locais (origem e destino). Deseja continuar?`
          : `Excluir transferência #${item.idTransferenciaEstoque}? Esta ação não pode ser desfeita.`,
        buttonConfirm: 'Excluir',
        buttonClose: 'Cancelar',
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (!result?.confirm) return;
      this.transferenciaOrquestradorService.excluir(item.idTransferenciaEstoque).subscribe({
        next: (resp) => {
          if (!resp?.isError) {
            this.alertService.show('Sucesso', 'Transferência excluída.', AlertType.success);
            this.clickPesquisar();
          } else {
            this.alertService.show('Erro', resp.errorDescription, AlertType.error);
          }
        },
        error: () => this.alertService.show('Erro', 'Não foi possível excluir.', AlertType.error),
      });
    });
  }

  public excluirSelecionadas(): void {
    const selecionadas = this.selection.selected.filter(
      i => i.idStatusTransferencia === StatusTransferenciaEnum.Pendente
        || i.idStatusTransferencia === StatusTransferenciaEnum.Concluido
    );
    if (!selecionadas.length) return;

    const temConcluida = selecionadas.some(i => i.idStatusTransferencia === StatusTransferenciaEnum.Concluido);
    const dialogRef = this.dialog.open(ConfirmModalComponent, {
      data: {
        title: 'Excluir transferências',
        description: temConcluida
          ? `Excluir ${selecionadas.length} transferência(s) selecionada(s)? Transferências já realizadas terão a movimentação de estoque revertida nos locais de origem e destino.`
          : `Excluir ${selecionadas.length} transferência(s) selecionada(s)? Esta ação não pode ser desfeita.`,
        buttonConfirm: 'Excluir',
        buttonClose: 'Cancelar',
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (!result?.confirm) return;
      let concluidas = 0;
      for (const item of selecionadas) {
        this.transferenciaOrquestradorService.excluir(item.idTransferenciaEstoque).subscribe({
          next: () => {
            concluidas++;
            if (concluidas === selecionadas.length) {
              this.alertService.show('Sucesso', 'Transferências excluídas.', AlertType.success);
              this.clickPesquisar();
            }
          },
          error: () => {
            concluidas++;
            if (concluidas === selecionadas.length) {
              this.alertService.show('Aviso', 'Algumas transferências não puderam ser excluídas.', AlertType.warning);
              this.clickPesquisar();
            }
          },
        });
      }
    });
  }

  public isAllSelected(): boolean {
    return this.selection.selected.length === this.dataSource.data.length;
  }

  public toggleAllRows(): void {
    if (this.isAllSelected()) {
      this.selection.clear();
    } else {
      this.dataSource.data.forEach(row => this.selection.select(row));
    }
  }

  public get temSelecionadasExcluiveis(): boolean {
    return this.selection.selected.some(
      i => i.idStatusTransferencia === StatusTransferenciaEnum.Pendente
        || i.idStatusTransferencia === StatusTransferenciaEnum.Concluido
    );
  }

  public statusBadgeClass(idStatus: number): string {
    if (idStatus === StatusTransferenciaEnum.Pendente) return 'status-badge badge-amarelo';
    if (idStatus === StatusTransferenciaEnum.Falha) return 'status-badge badge-vermelho';
    if (idStatus === StatusTransferenciaEnum.EmTransito) return 'status-badge badge-azul';
    if (idStatus === StatusTransferenciaEnum.Concluido) return 'status-badge badge-verde';
    return 'status-badge badge-cinza'; // Cancelado e desconhecidos
  }
}
